// extracted by mini-css-extract-plugin
export default {"container":"deal-overview-component_container__Ew-tX","truncate-table":"deal-overview-component_truncate-table__JqK+j","table-text-faded":"deal-overview-component_table-text-faded__Sclli","idLabel":"deal-overview-component_idLabel__vEqtm","filterModalList":"deal-overview-component_filterModalList__mIlGp","filterModalItem":"deal-overview-component_filterModalItem__fmlrW"};
    if(module.hot) {
      // 1792500651501
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  